export default function Title(props: { text: string; variant: "soft" | "hard" }) {
  const hardVariant = {
    color: "#002035",
    fontFamily: "Roobert",
    fontSize: "19px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "23px",
    letterSpacing: "-0.38px",
    margin: "0px",
    alignSelf: "center",
  };

  const softVariant = {
    ...hardVariant,
    fontSize: "16px",
    fontWeight: "400",
    marginBottom: "10px",
  };

  const style = props.variant === "soft" ? softVariant : hardVariant;

  return <h6 style={style}>{props.text}</h6>;
}
